
import Vue from "vue";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { firebaseApp } from "@/main";

export default Vue.extend({
  name: "app",
  data: function () {
    return {
      drawer: null,
    };
  },
  async created() {
    window.addEventListener(
      "keydown",
      function (e) {
        if (e.keyCode !== 8) {
          // Only wanna prevent backspace.
          return;
        }

        const target = e.target as Element;
        window.console.log(target);
        if (
          target == document.body ||
          target.hasAttribute("readonly") ||
          ["submit", "checkbox", "button"].includes(target.getAttribute("type"))
        ) {
          e.preventDefault();
          return false;
        }
      },
      true
    );

    const auth = getAuth(firebaseApp);

    onAuthStateChanged(auth, function () {
      // this is for suppressing 'onAuthStateChanged' is defined but never used lint error
    });

    await signInAnonymously(auth);
  },
});
